




import Vue from 'vue';
import UsersAdd from '@/components/users/user-add.component.vue';

export default Vue.extend({
  components: {
    'user-add': UsersAdd
  }
});
